import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const CreateFormSubmissionDocument = gql`
    mutation CreateFormSubmission($payload: CreateFormSubmissionInput!) {
  createFormSubmission(payload: $payload) {
    _id
    template {
      _id
      title
      description
      fields {
        id
        type
        label
        required
        options
      }
    }
    responses {
      fieldId
      value
    }
    status
    submittedAt
    submittedBy {
      userInfo {
        name
        surname
      }
    }
    tags
    createdAt
    updatedAt
  }
}
    `;
export type CreateFormSubmissionMutationFn = Apollo.MutationFunction<Types.CreateFormSubmissionMutation, Types.CreateFormSubmissionMutationVariables>;

/**
 * __useCreateFormSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormSubmissionMutation, { data, loading, error }] = useCreateFormSubmissionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFormSubmissionMutation, Types.CreateFormSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFormSubmissionMutation, Types.CreateFormSubmissionMutationVariables>(CreateFormSubmissionDocument, options);
      }
export type CreateFormSubmissionMutationHookResult = ReturnType<typeof useCreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationResult = Apollo.MutationResult<Types.CreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationOptions = Apollo.BaseMutationOptions<Types.CreateFormSubmissionMutation, Types.CreateFormSubmissionMutationVariables>;
export const CreateOrderDocument = gql`
    mutation createOrder($payload: CreateOrderInput!) {
  createOrder(payload: $payload) {
    _id
    referenceId
    consultation {
      _id
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<Types.CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>;
export const CreatePaymentSessionDocument = gql`
    mutation CreatePaymentSession($payload: CreatePaymentSessionInput!) {
  createPaymentSession(payload: $payload) {
    sessionId
  }
}
    `;
export type CreatePaymentSessionMutationFn = Apollo.MutationFunction<Types.CreatePaymentSessionMutation, Types.CreatePaymentSessionMutationVariables>;

/**
 * __useCreatePaymentSessionMutation__
 *
 * To run a mutation, you first call `useCreatePaymentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentSessionMutation, { data, loading, error }] = useCreatePaymentSessionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreatePaymentSessionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePaymentSessionMutation, Types.CreatePaymentSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePaymentSessionMutation, Types.CreatePaymentSessionMutationVariables>(CreatePaymentSessionDocument, options);
      }
export type CreatePaymentSessionMutationHookResult = ReturnType<typeof useCreatePaymentSessionMutation>;
export type CreatePaymentSessionMutationResult = Apollo.MutationResult<Types.CreatePaymentSessionMutation>;
export type CreatePaymentSessionMutationOptions = Apollo.BaseMutationOptions<Types.CreatePaymentSessionMutation, Types.CreatePaymentSessionMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation deleteFiles($payload: DeleteFilesInput!) {
  deleteFiles(payload: $payload)
}
    `;
export type DeleteFilesMutationFn = Apollo.MutationFunction<Types.DeleteFilesMutation, Types.DeleteFilesMutationVariables>;

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFilesMutation, Types.DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFilesMutation, Types.DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = Apollo.MutationResult<Types.DeleteFilesMutation>;
export type DeleteFilesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFilesMutation, Types.DeleteFilesMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($orderId: String!) {
  deleteOrder(orderId: $orderId)
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<Types.DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>;
export const GeneratePresignedUrlDocument = gql`
    mutation GeneratePresignedUrl($payload: CreatePresignedUrlInput!) {
  generatePresignedUrl(payload: $payload)
}
    `;
export type GeneratePresignedUrlMutationFn = Apollo.MutationFunction<Types.GeneratePresignedUrlMutation, Types.GeneratePresignedUrlMutationVariables>;

/**
 * __useGeneratePresignedUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedUrlMutation, { data, loading, error }] = useGeneratePresignedUrlMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGeneratePresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.GeneratePresignedUrlMutation, Types.GeneratePresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GeneratePresignedUrlMutation, Types.GeneratePresignedUrlMutationVariables>(GeneratePresignedUrlDocument, options);
      }
export type GeneratePresignedUrlMutationHookResult = ReturnType<typeof useGeneratePresignedUrlMutation>;
export type GeneratePresignedUrlMutationResult = Apollo.MutationResult<Types.GeneratePresignedUrlMutation>;
export type GeneratePresignedUrlMutationOptions = Apollo.BaseMutationOptions<Types.GeneratePresignedUrlMutation, Types.GeneratePresignedUrlMutationVariables>;
export const AddSavedAddressDocument = gql`
    mutation addSavedAddress($payload: SavedAddressInput!) {
  addSavedAddress(payload: $payload) {
    _id
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
  }
}
    `;
export type AddSavedAddressMutationFn = Apollo.MutationFunction<Types.AddSavedAddressMutation, Types.AddSavedAddressMutationVariables>;

/**
 * __useAddSavedAddressMutation__
 *
 * To run a mutation, you first call `useAddSavedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSavedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSavedAddressMutation, { data, loading, error }] = useAddSavedAddressMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddSavedAddressMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddSavedAddressMutation, Types.AddSavedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddSavedAddressMutation, Types.AddSavedAddressMutationVariables>(AddSavedAddressDocument, options);
      }
export type AddSavedAddressMutationHookResult = ReturnType<typeof useAddSavedAddressMutation>;
export type AddSavedAddressMutationResult = Apollo.MutationResult<Types.AddSavedAddressMutation>;
export type AddSavedAddressMutationOptions = Apollo.BaseMutationOptions<Types.AddSavedAddressMutation, Types.AddSavedAddressMutationVariables>;
export const UpdateSavedAddressDocument = gql`
    mutation updateSavedAddress($payload: UpdateSavedAddressInput!) {
  updateSavedAddress(payload: $payload) {
    _id
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
  }
}
    `;
export type UpdateSavedAddressMutationFn = Apollo.MutationFunction<Types.UpdateSavedAddressMutation, Types.UpdateSavedAddressMutationVariables>;

/**
 * __useUpdateSavedAddressMutation__
 *
 * To run a mutation, you first call `useUpdateSavedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedAddressMutation, { data, loading, error }] = useUpdateSavedAddressMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateSavedAddressMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSavedAddressMutation, Types.UpdateSavedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSavedAddressMutation, Types.UpdateSavedAddressMutationVariables>(UpdateSavedAddressDocument, options);
      }
export type UpdateSavedAddressMutationHookResult = ReturnType<typeof useUpdateSavedAddressMutation>;
export type UpdateSavedAddressMutationResult = Apollo.MutationResult<Types.UpdateSavedAddressMutation>;
export type UpdateSavedAddressMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSavedAddressMutation, Types.UpdateSavedAddressMutationVariables>;
export const DeleteSavedAddressDocument = gql`
    mutation deleteSavedAddress($addressId: String!) {
  deleteSavedAddress(addressId: $addressId) {
    _id
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
  }
}
    `;
export type DeleteSavedAddressMutationFn = Apollo.MutationFunction<Types.DeleteSavedAddressMutation, Types.DeleteSavedAddressMutationVariables>;

/**
 * __useDeleteSavedAddressMutation__
 *
 * To run a mutation, you first call `useDeleteSavedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedAddressMutation, { data, loading, error }] = useDeleteSavedAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useDeleteSavedAddressMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSavedAddressMutation, Types.DeleteSavedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSavedAddressMutation, Types.DeleteSavedAddressMutationVariables>(DeleteSavedAddressDocument, options);
      }
export type DeleteSavedAddressMutationHookResult = ReturnType<typeof useDeleteSavedAddressMutation>;
export type DeleteSavedAddressMutationResult = Apollo.MutationResult<Types.DeleteSavedAddressMutation>;
export type DeleteSavedAddressMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSavedAddressMutation, Types.DeleteSavedAddressMutationVariables>;
export const SendExpertiseMessageDocument = gql`
    mutation SendExpertiseMessage($payload: SendExpertiseMessageInput!) {
  sendExpertiseMessage(payload: $payload) {
    _id
    messages {
      content
      author {
        _id
        userInfo {
          name
          surname
        }
      }
      date
      readBy {
        _id
      }
    }
  }
}
    `;
export type SendExpertiseMessageMutationFn = Apollo.MutationFunction<Types.SendExpertiseMessageMutation, Types.SendExpertiseMessageMutationVariables>;

/**
 * __useSendExpertiseMessageMutation__
 *
 * To run a mutation, you first call `useSendExpertiseMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendExpertiseMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendExpertiseMessageMutation, { data, loading, error }] = useSendExpertiseMessageMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendExpertiseMessageMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendExpertiseMessageMutation, Types.SendExpertiseMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendExpertiseMessageMutation, Types.SendExpertiseMessageMutationVariables>(SendExpertiseMessageDocument, options);
      }
export type SendExpertiseMessageMutationHookResult = ReturnType<typeof useSendExpertiseMessageMutation>;
export type SendExpertiseMessageMutationResult = Apollo.MutationResult<Types.SendExpertiseMessageMutation>;
export type SendExpertiseMessageMutationOptions = Apollo.BaseMutationOptions<Types.SendExpertiseMessageMutation, Types.SendExpertiseMessageMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($payload: SignUpInput!) {
  signUp(payload: $payload)
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<Types.SignUpMutation, Types.SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignUpMutation, Types.SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignUpMutation, Types.SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<Types.SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<Types.SignUpMutation, Types.SignUpMutationVariables>;
export const UpdateConsultationStatusDocument = gql`
    mutation updateConsultationStatus($payload: UpdateConsultationStatus!) {
  updateConsultationStatus(payload: $payload) {
    _id
    status
  }
}
    `;
export type UpdateConsultationStatusMutationFn = Apollo.MutationFunction<Types.UpdateConsultationStatusMutation, Types.UpdateConsultationStatusMutationVariables>;

/**
 * __useUpdateConsultationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateConsultationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultationStatusMutation, { data, loading, error }] = useUpdateConsultationStatusMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateConsultationStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateConsultationStatusMutation, Types.UpdateConsultationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateConsultationStatusMutation, Types.UpdateConsultationStatusMutationVariables>(UpdateConsultationStatusDocument, options);
      }
export type UpdateConsultationStatusMutationHookResult = ReturnType<typeof useUpdateConsultationStatusMutation>;
export type UpdateConsultationStatusMutationResult = Apollo.MutationResult<Types.UpdateConsultationStatusMutation>;
export type UpdateConsultationStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateConsultationStatusMutation, Types.UpdateConsultationStatusMutationVariables>;
export const UpdateMyInfosDocument = gql`
    mutation updateMyInfos($payload: UpdatePatientInput!) {
  updateMyInfos(payload: $payload) {
    _id
    userInfo {
      name
      surname
      language
    }
  }
}
    `;
export type UpdateMyInfosMutationFn = Apollo.MutationFunction<Types.UpdateMyInfosMutation, Types.UpdateMyInfosMutationVariables>;

/**
 * __useUpdateMyInfosMutation__
 *
 * To run a mutation, you first call `useUpdateMyInfosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyInfosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyInfosMutation, { data, loading, error }] = useUpdateMyInfosMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateMyInfosMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyInfosMutation, Types.UpdateMyInfosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyInfosMutation, Types.UpdateMyInfosMutationVariables>(UpdateMyInfosDocument, options);
      }
export type UpdateMyInfosMutationHookResult = ReturnType<typeof useUpdateMyInfosMutation>;
export type UpdateMyInfosMutationResult = Apollo.MutationResult<Types.UpdateMyInfosMutation>;
export type UpdateMyInfosMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyInfosMutation, Types.UpdateMyInfosMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($orderId: String!, $input: CreateOrderInput!) {
  updateOrder(orderId: $orderId, input: $input) {
    _id
    status
    comment
    files {
      filename
      key
      objectType
      uploadedBy
      url
    }
    referenceId
    startDate
    speciality
    meetingPlace {
      description
      placeId
    }
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<Types.UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>;
export const UpdateOrderStatusDocument = gql`
    mutation updateOrderStatus($payload: UpdateOrderStatus!) {
  updateOrderStatus(payload: $payload) {
    _id
    status
    formSubmission {
      _id
      template {
        _id
        title
        description
        fields {
          id
          type
          label
          required
          options
        }
      }
      responses {
        fieldId
        value
      }
      status
      submittedAt
      submittedBy {
        userInfo {
          name
          surname
        }
      }
      tags
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateOrderStatusMutationFn = Apollo.MutationFunction<Types.UpdateOrderStatusMutation, Types.UpdateOrderStatusMutationVariables>;

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderStatusMutation, Types.UpdateOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderStatusMutation, Types.UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, options);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = Apollo.MutationResult<Types.UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderStatusMutation, Types.UpdateOrderStatusMutationVariables>;
export const UpdatePatientDataReuseConsentDocument = gql`
    mutation updatePatientDataReuseConsent($payload: UpdatePatientDataReuseConsentInput!) {
  updatePatientDataReuseConsent(payload: $payload) {
    _id
    patientConsent {
      recordingConsent
      dataReuseConsent
    }
  }
}
    `;
export type UpdatePatientDataReuseConsentMutationFn = Apollo.MutationFunction<Types.UpdatePatientDataReuseConsentMutation, Types.UpdatePatientDataReuseConsentMutationVariables>;

/**
 * __useUpdatePatientDataReuseConsentMutation__
 *
 * To run a mutation, you first call `useUpdatePatientDataReuseConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientDataReuseConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientDataReuseConsentMutation, { data, loading, error }] = useUpdatePatientDataReuseConsentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePatientDataReuseConsentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePatientDataReuseConsentMutation, Types.UpdatePatientDataReuseConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePatientDataReuseConsentMutation, Types.UpdatePatientDataReuseConsentMutationVariables>(UpdatePatientDataReuseConsentDocument, options);
      }
export type UpdatePatientDataReuseConsentMutationHookResult = ReturnType<typeof useUpdatePatientDataReuseConsentMutation>;
export type UpdatePatientDataReuseConsentMutationResult = Apollo.MutationResult<Types.UpdatePatientDataReuseConsentMutation>;
export type UpdatePatientDataReuseConsentMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePatientDataReuseConsentMutation, Types.UpdatePatientDataReuseConsentMutationVariables>;
export const UpdatePatientLocationDocument = gql`
    mutation updatePatientLocation($payload: UpdatePatientLocationInput!) {
  updatePatientLocation(payload: $payload) {
    _id
    patientLocation {
      description
      placeId
    }
  }
}
    `;
export type UpdatePatientLocationMutationFn = Apollo.MutationFunction<Types.UpdatePatientLocationMutation, Types.UpdatePatientLocationMutationVariables>;

/**
 * __useUpdatePatientLocationMutation__
 *
 * To run a mutation, you first call `useUpdatePatientLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientLocationMutation, { data, loading, error }] = useUpdatePatientLocationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePatientLocationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePatientLocationMutation, Types.UpdatePatientLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePatientLocationMutation, Types.UpdatePatientLocationMutationVariables>(UpdatePatientLocationDocument, options);
      }
export type UpdatePatientLocationMutationHookResult = ReturnType<typeof useUpdatePatientLocationMutation>;
export type UpdatePatientLocationMutationResult = Apollo.MutationResult<Types.UpdatePatientLocationMutation>;
export type UpdatePatientLocationMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePatientLocationMutation, Types.UpdatePatientLocationMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($payload: UploadFileInput!) {
  uploadFile(payload: $payload) {
    _id
    files {
      filename
      key
      objectType
      url
    }
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<Types.UploadFileMutation, Types.UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadFileMutation, Types.UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<Types.UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>;
export const GetChimeMeetingDocument = gql`
    query getChimeMeeting($meetingType: String!, $roomOrConsultationId: String!, $userId: String!) {
  chimeMeeting(
    meetingType: $meetingType
    roomOrConsultationId: $roomOrConsultationId
    userId: $userId
  ) {
    attendeeInfo {
      AttendeeId
      ExternalUserId
      JoinToken
    }
    meetingInfo {
      MeetingId
      MediaPlacement {
        AudioHostUrl
        AudioFallbackUrl
        ScreenDataUrl
        ScreenSharingUrl
        ScreenViewingUrl
        SignalingUrl
        TurnControlUrl
        EventIngestionUrl
      }
    }
  }
}
    `;

/**
 * __useGetChimeMeetingQuery__
 *
 * To run a query within a React component, call `useGetChimeMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChimeMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChimeMeetingQuery({
 *   variables: {
 *      meetingType: // value for 'meetingType'
 *      roomOrConsultationId: // value for 'roomOrConsultationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChimeMeetingQuery(baseOptions: Apollo.QueryHookOptions<Types.GetChimeMeetingQuery, Types.GetChimeMeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetChimeMeetingQuery, Types.GetChimeMeetingQueryVariables>(GetChimeMeetingDocument, options);
      }
export function useGetChimeMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetChimeMeetingQuery, Types.GetChimeMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetChimeMeetingQuery, Types.GetChimeMeetingQueryVariables>(GetChimeMeetingDocument, options);
        }
export type GetChimeMeetingQueryHookResult = ReturnType<typeof useGetChimeMeetingQuery>;
export type GetChimeMeetingLazyQueryHookResult = ReturnType<typeof useGetChimeMeetingLazyQuery>;
export type GetChimeMeetingQueryResult = Apollo.QueryResult<Types.GetChimeMeetingQuery, Types.GetChimeMeetingQueryVariables>;
export const GetConsultationDocument = gql`
    query getConsultation($id: String!) {
  consultation(id: $id) {
    _id
    status
    startDate
    speciality
    medecin {
      _id
      userInfo {
        name
        surname
      }
    }
    waitingRoom
  }
}
    `;

/**
 * __useGetConsultationQuery__
 *
 * To run a query within a React component, call `useGetConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultationQuery(baseOptions: Apollo.QueryHookOptions<Types.GetConsultationQuery, Types.GetConsultationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetConsultationQuery, Types.GetConsultationQueryVariables>(GetConsultationDocument, options);
      }
export function useGetConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetConsultationQuery, Types.GetConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetConsultationQuery, Types.GetConsultationQueryVariables>(GetConsultationDocument, options);
        }
export type GetConsultationQueryHookResult = ReturnType<typeof useGetConsultationQuery>;
export type GetConsultationLazyQueryHookResult = ReturnType<typeof useGetConsultationLazyQuery>;
export type GetConsultationQueryResult = Apollo.QueryResult<Types.GetConsultationQuery, Types.GetConsultationQueryVariables>;
export const GetEstablishmentDocument = gql`
    query getEstablishment($slug: String!) {
  establishment(slug: $slug) {
    name
    meetingLinks {
      _id
      name
      slug
      specialities {
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetEstablishmentQuery__
 *
 * To run a query within a React component, call `useGetEstablishmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstablishmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstablishmentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEstablishmentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEstablishmentQuery, Types.GetEstablishmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEstablishmentQuery, Types.GetEstablishmentQueryVariables>(GetEstablishmentDocument, options);
      }
export function useGetEstablishmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEstablishmentQuery, Types.GetEstablishmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEstablishmentQuery, Types.GetEstablishmentQueryVariables>(GetEstablishmentDocument, options);
        }
export type GetEstablishmentQueryHookResult = ReturnType<typeof useGetEstablishmentQuery>;
export type GetEstablishmentLazyQueryHookResult = ReturnType<typeof useGetEstablishmentLazyQuery>;
export type GetEstablishmentQueryResult = Apollo.QueryResult<Types.GetEstablishmentQuery, Types.GetEstablishmentQueryVariables>;
export const GetFormTemplateDocument = gql`
    query GetFormTemplate($id: String!) {
  formTemplate(id: $id) {
    _id
    title
    description
    version
    categories
    tags
    fields {
      id
      type
      label
      required
      options
    }
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFormTemplateQuery__
 *
 * To run a query within a React component, call `useGetFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormTemplateQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFormTemplateQuery, Types.GetFormTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFormTemplateQuery, Types.GetFormTemplateQueryVariables>(GetFormTemplateDocument, options);
      }
export function useGetFormTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFormTemplateQuery, Types.GetFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFormTemplateQuery, Types.GetFormTemplateQueryVariables>(GetFormTemplateDocument, options);
        }
export type GetFormTemplateQueryHookResult = ReturnType<typeof useGetFormTemplateQuery>;
export type GetFormTemplateLazyQueryHookResult = ReturnType<typeof useGetFormTemplateLazyQuery>;
export type GetFormTemplateQueryResult = Apollo.QueryResult<Types.GetFormTemplateQuery, Types.GetFormTemplateQueryVariables>;
export const GetActiveFormTemplatesDocument = gql`
    query GetActiveFormTemplates {
  activeFormTemplates {
    _id
    title
    description
    version
    categories
    tags
    fields {
      id
      type
      label
      required
      options
    }
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetActiveFormTemplatesQuery__
 *
 * To run a query within a React component, call `useGetActiveFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveFormTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveFormTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetActiveFormTemplatesQuery, Types.GetActiveFormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetActiveFormTemplatesQuery, Types.GetActiveFormTemplatesQueryVariables>(GetActiveFormTemplatesDocument, options);
      }
export function useGetActiveFormTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetActiveFormTemplatesQuery, Types.GetActiveFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetActiveFormTemplatesQuery, Types.GetActiveFormTemplatesQueryVariables>(GetActiveFormTemplatesDocument, options);
        }
export type GetActiveFormTemplatesQueryHookResult = ReturnType<typeof useGetActiveFormTemplatesQuery>;
export type GetActiveFormTemplatesLazyQueryHookResult = ReturnType<typeof useGetActiveFormTemplatesLazyQuery>;
export type GetActiveFormTemplatesQueryResult = Apollo.QueryResult<Types.GetActiveFormTemplatesQuery, Types.GetActiveFormTemplatesQueryVariables>;
export const GetFormSubmissionDocument = gql`
    query GetFormSubmission($id: String!) {
  formSubmission(id: $id) {
    _id
    template {
      _id
      title
      description
      fields {
        id
        type
        label
        required
        options
      }
    }
    responses {
      fieldId
      value
    }
    status
    submittedAt
    submittedBy {
      userInfo {
        name
        surname
      }
    }
    tags
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFormSubmissionQuery__
 *
 * To run a query within a React component, call `useGetFormSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormSubmissionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFormSubmissionQuery, Types.GetFormSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFormSubmissionQuery, Types.GetFormSubmissionQueryVariables>(GetFormSubmissionDocument, options);
      }
export function useGetFormSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFormSubmissionQuery, Types.GetFormSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFormSubmissionQuery, Types.GetFormSubmissionQueryVariables>(GetFormSubmissionDocument, options);
        }
export type GetFormSubmissionQueryHookResult = ReturnType<typeof useGetFormSubmissionQuery>;
export type GetFormSubmissionLazyQueryHookResult = ReturnType<typeof useGetFormSubmissionLazyQuery>;
export type GetFormSubmissionQueryResult = Apollo.QueryResult<Types.GetFormSubmissionQuery, Types.GetFormSubmissionQueryVariables>;
export const GetPatientWaitingStatusDocument = gql`
    query getPatientWaitingStatus($consultationId: String!) {
  getPatientWaitingStatus(consultationId: $consultationId) {
    consultationId
    doctorStatus
    canJoin
  }
}
    `;

/**
 * __useGetPatientWaitingStatusQuery__
 *
 * To run a query within a React component, call `useGetPatientWaitingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientWaitingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientWaitingStatusQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useGetPatientWaitingStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPatientWaitingStatusQuery, Types.GetPatientWaitingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPatientWaitingStatusQuery, Types.GetPatientWaitingStatusQueryVariables>(GetPatientWaitingStatusDocument, options);
      }
export function useGetPatientWaitingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPatientWaitingStatusQuery, Types.GetPatientWaitingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPatientWaitingStatusQuery, Types.GetPatientWaitingStatusQueryVariables>(GetPatientWaitingStatusDocument, options);
        }
export type GetPatientWaitingStatusQueryHookResult = ReturnType<typeof useGetPatientWaitingStatusQuery>;
export type GetPatientWaitingStatusLazyQueryHookResult = ReturnType<typeof useGetPatientWaitingStatusLazyQuery>;
export type GetPatientWaitingStatusQueryResult = Apollo.QueryResult<Types.GetPatientWaitingStatusQuery, Types.GetPatientWaitingStatusQueryVariables>;
export const GetPaymentStatusDocument = gql`
    query GetPaymentStatus($payload: GetPaymentStatusInput!) {
  getPaymentStatus(payload: $payload) {
    paid
    sessionId
    receiptUrl
  }
}
    `;

/**
 * __useGetPaymentStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStatusQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetPaymentStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPaymentStatusQuery, Types.GetPaymentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPaymentStatusQuery, Types.GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
      }
export function useGetPaymentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPaymentStatusQuery, Types.GetPaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPaymentStatusQuery, Types.GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
        }
export type GetPaymentStatusQueryHookResult = ReturnType<typeof useGetPaymentStatusQuery>;
export type GetPaymentStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentStatusLazyQuery>;
export type GetPaymentStatusQueryResult = Apollo.QueryResult<Types.GetPaymentStatusQuery, Types.GetPaymentStatusQueryVariables>;
export const GetMeetingLinkDocument = gql`
    query getMeetingLink($slug: String!) {
  meetingLink(slug: $slug) {
    _id
    availabilities {
      _id
      address {
        description
        placeId
      }
      additionalAddress
      avgMeetingDuration
      isRecurrence
      meetingPlace
      notes
      formTemplate {
        _id
        title
        description
        fields {
          id
          type
          label
          required
          options
        }
        isActive
      }
      recurrenceDays {
        day
        periods {
          open
          close
        }
        timeZone
      }
      scheduledDays {
        day
        format
        periods {
          open
          close
        }
        timeZone
      }
      specialities
      unavailabilities {
        _id
        startDate
        endDate
        startTime
        endTime
      }
      paymentConfig {
        requiresPayment
        basePrice
        paymentReceiver {
          _id
          userInfo {
            name
            surname
          }
          stripe
          stripeActivated
        }
        priceModifiers {
          meetingPlace
          modifier
        }
      }
      serviceArea {
        allowedPostalCodes
        center {
          description
          placeId
          lat
          lng
        }
        radiusKm
      }
    }
    busySlots {
      start
      end
    }
    createdBy {
      _id
      establishment {
        name
        slug
      }
      userInfo {
        name
        surname
      }
      slug
    }
    description
    name
    specialities {
      code
      name
      price
    }
    staffs {
      _id
      userInfo {
        name
        surname
      }
      status
      stripe
      stripeActivated
    }
    immediateConsultationConfig {
      enabled
      maxWaitingPatients
      requirePaymentUpfront
      price
      paymentReceiver {
        _id
        userInfo {
          name
          surname
        }
        stripe
        stripeActivated
      }
    }
    waitingRoom {
      _id
      name
      avgWaitingTime
    }
  }
}
    `;

/**
 * __useGetMeetingLinkQuery__
 *
 * To run a query within a React component, call `useGetMeetingLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingLinkQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetMeetingLinkQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMeetingLinkQuery, Types.GetMeetingLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMeetingLinkQuery, Types.GetMeetingLinkQueryVariables>(GetMeetingLinkDocument, options);
      }
export function useGetMeetingLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMeetingLinkQuery, Types.GetMeetingLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMeetingLinkQuery, Types.GetMeetingLinkQueryVariables>(GetMeetingLinkDocument, options);
        }
export type GetMeetingLinkQueryHookResult = ReturnType<typeof useGetMeetingLinkQuery>;
export type GetMeetingLinkLazyQueryHookResult = ReturnType<typeof useGetMeetingLinkLazyQuery>;
export type GetMeetingLinkQueryResult = Apollo.QueryResult<Types.GetMeetingLinkQuery, Types.GetMeetingLinkQueryVariables>;
export const SearchMeetingLinksDocument = gql`
    query searchMeetingLinks($phrase: String!) {
  meetingLinksSearch(phrase: $phrase) {
    __typename
    ... on Etablissement {
      _id
      name
      slug
    }
    ... on MeetingLink {
      _id
      name
      slug
      specialities {
        code
        name
      }
    }
  }
}
    `;

/**
 * __useSearchMeetingLinksQuery__
 *
 * To run a query within a React component, call `useSearchMeetingLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMeetingLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMeetingLinksQuery({
 *   variables: {
 *      phrase: // value for 'phrase'
 *   },
 * });
 */
export function useSearchMeetingLinksQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchMeetingLinksQuery, Types.SearchMeetingLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchMeetingLinksQuery, Types.SearchMeetingLinksQueryVariables>(SearchMeetingLinksDocument, options);
      }
export function useSearchMeetingLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchMeetingLinksQuery, Types.SearchMeetingLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchMeetingLinksQuery, Types.SearchMeetingLinksQueryVariables>(SearchMeetingLinksDocument, options);
        }
export type SearchMeetingLinksQueryHookResult = ReturnType<typeof useSearchMeetingLinksQuery>;
export type SearchMeetingLinksLazyQueryHookResult = ReturnType<typeof useSearchMeetingLinksLazyQuery>;
export type SearchMeetingLinksQueryResult = Apollo.QueryResult<Types.SearchMeetingLinksQuery, Types.SearchMeetingLinksQueryVariables>;
export const GetMyInfosDocument = gql`
    query getMyInfos {
  myInfos {
    _id
    agreement
    isProfileComplete
    isConsultationReady
    consultations {
      _id
      autoRecording
      recordingConsentPending
      biologicals {
        id
      }
      commentaire
      createdBy {
        userInfo {
          name
          surname
        }
      }
      endDate
      establishment {
        _id
        name
      }
      files {
        filename
        key
        url
      }
      medecin {
        _id
        userInfo {
          gender
          name
          surname
        }
        civility
        title
        speciality
        teleconsultationTraining {
          type
          description
        }
        cabinetAddresses {
          description
        }
      }
      pds {
        _id
        userInfo {
          name
          surname
          gender
        }
      }
      mesures {
        label
        order
        unit
        value
      }
      paid
      patientConsent {
        recordingConsent
      }
      patientLocation {
        description
        placeId
      }
      startDate
      status
      type
      waitingRoom
    }
    email
    establishment {
      _id
      name
    }
    files {
      filename
      key
      url
    }
    userInfo {
      birthday
      gender
      name
      surname
      language
      birthName
      birthFirstName
      birthSurname
      birthPlace
      birthPlaceCode
    }
    orders {
      _id
      acceptedBy {
        userInfo {
          gender
          name
          surname
        }
      }
      speciality
      referenceId
      startDate
      status
      meetingPlace {
        description
        placeId
        apartment
        floor
        doorCode
        instructions
        postalCode
      }
      meetingLink {
        _id
        description
        isPrioritized
        name
        specialities {
          name
          price
        }
        staffs {
          userInfo {
            name
          }
        }
      }
      files {
        url
        key
        filename
      }
      formSubmission {
        _id
        template {
          _id
          title
          description
          fields {
            id
            type
            label
            required
            options
          }
        }
        responses {
          fieldId
          value
        }
        status
        submittedAt
        submittedBy {
          userInfo {
            name
            surname
          }
        }
        tags
        createdAt
        updatedAt
      }
    }
    secu
    insNIR
    insOID
    contactInfo {
      phone
      cp
      city
      street
      country
    }
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
    attendingPhysician {
      firstname
      lastname
      gender
      email
      phone
    }
    parents {
      _id
      city
      cp
      email
      firstname
      lastname
      phone
      street
    }
    insured
    insuredRelationship
    insuranceProvider
    primaryInsurance
    secondaryInsurance
    primaryPolicy
    secondaryPolicy
    primaryPharmacy
    events {
      _id
      createdAt
      object_id
      object_type
      channels
      type
      recipients {
        userId
        type
        read
      }
    }
    expertises {
      _id
      status
      startDate
      endDate
      speciality
      conclusion
      diagnostic
      comment
      consultations {
        _id
        startDate
        status
        speciality
      }
      files {
        filename
        key
        objectType
        url
      }
      chatRoom {
        _id
        messages {
          content
          author {
            _id
            userInfo {
              name
              surname
            }
          }
          readBy {
            _id
          }
          date
        }
      }
      medecin {
        _id
        userInfo {
          name
          surname
        }
        speciality
      }
      createdBy {
        _id
        userInfo {
          name
          surname
        }
        speciality
        status
      }
      patient {
        _id
      }
      formSubmissions {
        _id
        template {
          _id
          title
          description
          version
          fields {
            id
            type
            label
            required
            options
          }
        }
        responses {
          fieldId
          value
        }
        status
        submittedBy {
          userInfo {
            name
            surname
          }
        }
        tags
        submittedAt
        createdAt
        updatedAt
      }
    }
    formSubmissions {
      _id
      template {
        _id
        title
        description
        version
        categories
        tags
        fields {
          id
          type
          label
          required
          options
        }
      }
      patient {
        _id
      }
      consultation {
        _id
        startDate
        status
      }
      expertise {
        _id
        startDate
        status
      }
      responses {
        fieldId
        value
      }
      status
      submittedBy {
        userInfo {
          name
          surname
        }
      }
      ethicsResponse
      respondedBy {
        userInfo {
          name
          surname
        }
      }
      respondedAt
      tags
      submittedAt
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetMyInfosQuery__
 *
 * To run a query within a React component, call `useGetMyInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInfosQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMyInfosQuery, Types.GetMyInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyInfosQuery, Types.GetMyInfosQueryVariables>(GetMyInfosDocument, options);
      }
export function useGetMyInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyInfosQuery, Types.GetMyInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyInfosQuery, Types.GetMyInfosQueryVariables>(GetMyInfosDocument, options);
        }
export type GetMyInfosQueryHookResult = ReturnType<typeof useGetMyInfosQuery>;
export type GetMyInfosLazyQueryHookResult = ReturnType<typeof useGetMyInfosLazyQuery>;
export type GetMyInfosQueryResult = Apollo.QueryResult<Types.GetMyInfosQuery, Types.GetMyInfosQueryVariables>;
export const GetOrderDocument = gql`
    query getOrder($orderId: String!) {
  meetingLinkOrder(orderId: $orderId) {
    _id
    meetingPlace {
      description
    }
    files {
      filename
      key
      url
    }
    referenceId
    speciality
    startDate
    status
    consultation {
      _id
    }
  }
}
    `;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrderQuery, Types.GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrderQuery, Types.GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrderQuery, Types.GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrderQuery, Types.GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<Types.GetOrderQuery, Types.GetOrderQueryVariables>;
export const GetPatientFilesDocument = gql`
    query getPatientFiles {
  myInfos {
    _id
    consultations {
      endDate
      files {
        filename
        key
        url
      }
      startDate
      status
      _id
    }
    files {
      filename
      key
      url
    }
  }
}
    `;

/**
 * __useGetPatientFilesQuery__
 *
 * To run a query within a React component, call `useGetPatientFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPatientFilesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetPatientFilesQuery, Types.GetPatientFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPatientFilesQuery, Types.GetPatientFilesQueryVariables>(GetPatientFilesDocument, options);
      }
export function useGetPatientFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPatientFilesQuery, Types.GetPatientFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPatientFilesQuery, Types.GetPatientFilesQueryVariables>(GetPatientFilesDocument, options);
        }
export type GetPatientFilesQueryHookResult = ReturnType<typeof useGetPatientFilesQuery>;
export type GetPatientFilesLazyQueryHookResult = ReturnType<typeof useGetPatientFilesLazyQuery>;
export type GetPatientFilesQueryResult = Apollo.QueryResult<Types.GetPatientFilesQuery, Types.GetPatientFilesQueryVariables>;
export const ListPrioritizedMeetingLinksDocument = gql`
    query listPrioritizedMeetingLinks {
  prioritizedMeetingLinks {
    _id
    availabilities {
      _id
      address {
        description
        placeId
      }
    }
    description
    name
    slug
    specialities {
      code
      name
    }
  }
}
    `;

/**
 * __useListPrioritizedMeetingLinksQuery__
 *
 * To run a query within a React component, call `useListPrioritizedMeetingLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPrioritizedMeetingLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPrioritizedMeetingLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPrioritizedMeetingLinksQuery(baseOptions?: Apollo.QueryHookOptions<Types.ListPrioritizedMeetingLinksQuery, Types.ListPrioritizedMeetingLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListPrioritizedMeetingLinksQuery, Types.ListPrioritizedMeetingLinksQueryVariables>(ListPrioritizedMeetingLinksDocument, options);
      }
export function useListPrioritizedMeetingLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListPrioritizedMeetingLinksQuery, Types.ListPrioritizedMeetingLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListPrioritizedMeetingLinksQuery, Types.ListPrioritizedMeetingLinksQueryVariables>(ListPrioritizedMeetingLinksDocument, options);
        }
export type ListPrioritizedMeetingLinksQueryHookResult = ReturnType<typeof useListPrioritizedMeetingLinksQuery>;
export type ListPrioritizedMeetingLinksLazyQueryHookResult = ReturnType<typeof useListPrioritizedMeetingLinksLazyQuery>;
export type ListPrioritizedMeetingLinksQueryResult = Apollo.QueryResult<Types.ListPrioritizedMeetingLinksQuery, Types.ListPrioritizedMeetingLinksQueryVariables>;
export const GetTrackedOrderDocument = gql`
    query getTrackedOrder($referenceId: String!) {
  trackedOrder(referenceId: $referenceId) {
    _id
    referenceId
    meetingPlace {
      description
    }
    createdBy {
      email
      contactInfo {
        phone
      }
      userInfo {
        name
        surname
      }
    }
    speciality
    startDate
    status
    consultation {
      _id
    }
    files {
      filename
      key
      url
    }
    meetingLink {
      _id
      name
    }
    acceptedBy {
      userInfo {
        gender
        name
        surname
      }
      speciality
    }
  }
}
    `;

/**
 * __useGetTrackedOrderQuery__
 *
 * To run a query within a React component, call `useGetTrackedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedOrderQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useGetTrackedOrderQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTrackedOrderQuery, Types.GetTrackedOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTrackedOrderQuery, Types.GetTrackedOrderQueryVariables>(GetTrackedOrderDocument, options);
      }
export function useGetTrackedOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTrackedOrderQuery, Types.GetTrackedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTrackedOrderQuery, Types.GetTrackedOrderQueryVariables>(GetTrackedOrderDocument, options);
        }
export type GetTrackedOrderQueryHookResult = ReturnType<typeof useGetTrackedOrderQuery>;
export type GetTrackedOrderLazyQueryHookResult = ReturnType<typeof useGetTrackedOrderLazyQuery>;
export type GetTrackedOrderQueryResult = Apollo.QueryResult<Types.GetTrackedOrderQuery, Types.GetTrackedOrderQueryVariables>;